<template>
	<v-card class="create-card bg-secondary" width="800px" rounded="xl">
		<v-dialog class="loader" v-model="loader.showSubmittingLoader" persistent width="300px">
			<v-card>
				<v-card-title> Agent Details </v-card-title>
				<v-card-text style="display: grid; justify-content: center">
					<v-progress-circular indeterminate size="40"></v-progress-circular>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-card-title class="card__title__top">
			<strong>{{ $t('agent_information') }}</strong>
			<v-icon class="icon" @click="closeDialog">mdi-close</v-icon>
		</v-card-title>
		<v-header>
			<div style="height: 7rem; background-color: #ffc2c6"></div>
		</v-header>
		<v-card-text class="bg-white">
			<div>
				<v-avatar color="grey" size="150" class="ml-5" style=" position: relative;margin-top: -6rem;"
					:image="agent?.pictureUrl">
				</v-avatar>
				<v-btn size="45" icon="" style="
							position: absolute;
							left: 160px;
							z-index: 999;
							background-color: rgba(17, 17, 17, 0.7);
						" @click="pickFile">
					<v-icon size="24" class="text-white">
						mdi-image-edit
					</v-icon>
					<input ref="fileRef" class="d-none" type="file" @change="uploadImage($event)"></input>
				</v-btn>
				<div>
					<div class="mt-4">
						<label for="agentType" class="form-label">{{ $t('types_of_agent') }} <span>*</span></label>
						<v-select class="rounded-xl" density="compact" variant="outlined"
							:model-value="getMappedAgentType()" @update:model-value="setMappedAgentType"
							:items="['IT Service', 'ESG']" placeholder="Select Type of Agent">
						</v-select>
					</div>
					<v-row>
						<v-col cols="6">

							<div class="my-2">
								<label for="title" style="font-weight: 600">{{ $t('first_name') }}
									<span>*</span></label>
								<v-text-field variant="outlined" v-model="agent.firstName" density="compact"
									size="50"></v-text-field>

								<label for="title" style="font-weight: 600">{{ $t('email') }} <span>*</span></label>
								<v-text-field variant="outlined" v-model="agent.email" density="compact"
									size="50"></v-text-field>

								<label for="title" style="font-weight: 600">{{ $t('aka_name') }}<span>*</span></label>
								<v-text-field variant="outlined" v-model="agent.nickname"
									density="compact"></v-text-field>

								<label for="title" style="font-weight: 600">{{ $t('base_location')
								}}<span>*</span></label>
								<v-text-field variant="outlined" v-model="agent.address"
									density="compact"></v-text-field>
							</div>


						</v-col>

						<v-col cols="6">
							<div class="my-2">
								<div>
									<!-- <div>{{ agentDetails.agentCertificate[0] }}</div> -->
									<label for="title" style="font-weight: 600">{{ $t('last_name')
									}}<span>*</span></label>
									<v-text-field variant="outlined" v-model="agent.lastName" density="compact"
										size="50"></v-text-field>
								</div>

								<div>
									<label for="title" style="font-weight: 600">{{ $t('contact_number')
									}}<span>*</span></label>

									<vue-tel-input :enabledCountryCode="true" mode="international" v-model="agent.phone"
										style="
											padding: 0.3rem;
											
										"></vue-tel-input>
								</div>

								<div class="mt-5">
									<label for="title" style="font-weight: 600;">{{ $t('preferred_contact_time')
									}}<span>*</span></label>
									<v-select class="rounded-xl" density="compact" variant="outlined"
										placeholder="Pick your available time" v-model="agent.preferredContactTime"
										:items="timeRange" item-text="preferredTimeTable">
										<template v-slot:item="{ props, item }">
											<v-list-item v-bind="props" class="custom-item">
												{{ item.preferredTimeTable }}
											</v-list-item>
										</template>
										{{ items.preferredContactTime }}</v-select>
								</div>

								<div>
									<label for="title" style="font-weight: 600">{{ $t('available_time')
									}}<span>*</span></label>
									<v-select class="rounded-xl" density="compact" variant="outlined"
										placeholder="Pick your available time" v-model="agent.availableTime"
										:items="timeRange" item-text="timeTable">
										<template v-slot:item="{ props, item }">
											<v-list-item v-bind="props" class="custom-item">
												{{ item.timeTable }}
											</v-list-item>
										</template>
										{{ items.availableTime }}</v-select>
								</div>
							</div>
						</v-col>
					</v-row>
				</div>
				<div>
					<label for="title" style="font-weight: 600">{{ $t('skill_required') }}<span>*</span></label>
					<vue3-tags-input style="padding: 0.3rem; text-transform: capitalize; " :tags="tags"
						:placeholder="$t('enter_skills')" @on-tags-changed="handleChangeTag"></vue3-tags-input>
				</div>
				<div class="my-4">
					<label for="title" style="font-weight: 600">{{ $t('certificate') }}
						<span>({{ $t('optional') }})</span></label>
					<v-menu v-model="isCreateCertificatesOpen" location="top" :close-on-content-click="false">
						<template #activator="{ props: menuProps }">

							<div v-bind="menuProps"
								class=" v-text-field-height border rounded-lg d-flex align-center justify-space-between">
								<div style="display: flex; flex-wrap: wrap; gap: 4px;">
									<span v-if="selectedCertificates.length === 0" class="placeholder-text"
										style="color: rgba(153, 153, 153, 1)">
										{{ $t('select-certificate') }}
									</span>
									<v-chip v-for="item in selectedCertificates" :key="item" class="mr-1" :style="{
										'background-color': colorGenerator(item),
										'color': 'white',
									}">
										{{ item }}
									</v-chip>
								</div>
								<v-icon @click.stop="isCreateCertificatesOpen = true">
									{{
										isCreateCertificatesOpen ? "mdi-chevron-up" : "mdi-chevron-down"
									}}
								</v-icon>
							</div>

						</template>
						<v-list width="750px" class=' mb-2' style="max-height: 300px;">
							<v-btn class="text-none pa-5 d-flex ml-10 justify-center align-center"
								style="border: 1px solid rgba(153, 153, 153, 1); width: 90%;" variant="outlined"
								@click="handleAddItemsDialogOpen">
								<div class="d-flex align-center">+ {{ $t('create_certificate') }}</div>
							</v-btn>

							<v-divider class="ma-1 my-2" />

							<v-list-item v-for="(item, index) in certificates" :key="index">
								<div class="d-flex justify-space-between align-center" style="width: 100%; ">
									<div>{{ item.name }}
									</div>
									<v-radio :value="item.name" v-model="selectedCertificates"
										@click.stop="toggleCertificateSelection(item.name)"
										style="display: flex;justify-content: end; color: rgba(46, 204, 113, 1);"></v-radio>
									<v-icon color="red" class="mr-3"
										@click.stop="deleteCertificatePopup(item.id, item.name)"
										style="cursor: pointer;">
										mdi-trash-can-outline
									</v-icon>
								</div>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
				<div class="my-2">
					<label for="remote-access" class="form-label">{{ $t('able_to_work_remotely') }}
					</label>
					<v-radio-group v-model="agent.remote">
						<v-radio class="radio-class" color="#12C138" :label="$t('available')" :value="false"></v-radio>
						<v-radio class="radio-class" color="#12C138" :label="$t('unavailable')" :value="true"></v-radio>
					</v-radio-group>
				</div>
				<label for="certificate" class="form-label">{{ $t('certificate_file') }}
					<span>{{ $t('optional') }}</span></label>
				<div class="text-center my-2" style="
       				border: 1px solid rgba(221, 221, 221, 1);
					padding: 16px;
          			border-radius: 8px;
          			color: rgba(255, 255, 255, 1);" @click="triggerFileInput">
					<div>
						<v-icon color="rgba(255, 126, 135, 1)">mdi-file</v-icon>
					</div>
					<div class="text-decoration-underline font-weight-medium my-2"
						style="color: rgba(255, 126, 135, 1)">
						{{ $t('upload_file_or_image') }}
					</div>
					<!-- Hidden File Input -->
					<input type="file" ref="fileInput" style="display: none" @change="handleFileChange" multiple />
				</div>
				<!-- Display Selected Files -->
				<div v-if="selectedFiles.length > 0" class="mb-4">
					<v-row v-for="(file, index) in selectedFiles" :key="index">
						<v-col>
							<div style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                border: 1px solid rgba(46, 204, 113, 0.2);
                padding: 10px;
                border-radius: 20px;
                width: 100%;
              ">
								<div class="d-flex align-center">
									<v-icon color="rgba(46, 204, 113, 1)">mdi-file-outline</v-icon>
									<span style="margin-left: 10px">{{ file.name || file.fileName }}</span>
								</div>
								<div style="display: flex; align-items: center">
									<div style="
                    background-color: rgba(46, 204, 113, 0.2);
                    border-radius: 8px;
                    padding: 1px;
                    margin-right: 10px;
                  ">
										<v-icon color="rgba(46, 204, 113, 1)">mdi-check-bold</v-icon>
									</div>

									<div style="
                    border: 1px solid grey;
                    padding: 5px;
                    border-radius: 15px;
                  ">
										<v-icon color="black" @click="removeFile(index)" class="cursor-pointer">
											mdi-close
										</v-icon>
									</div>
								</div>
							</div>
						</v-col>
					</v-row>
				</div>
			</div>
		</v-card-text>

		<v-card-actions class="card__footer">
			<v-card-title class="card__title__bottom" style="display: flex; justify-content: space-between">
				<div>
					<button class="reset-button" @click="closeDialog">
						{{ $t('cancel') }}
					</button>
				</div>

				<div style="display: flex">
					<div>
						<button class="create-button" @click="updateAgentProfile">
							{{ $t('save_change') }}
						</button>
					</div>
				</div>
			</v-card-title>
		</v-card-actions>
		<v-dialog v-model="isAddItemsDialogOpen" width="500px">
			<v-card rounded='xl'>
				<v-card-header style="background-color: rgba(37, 37, 37, 1)">
					<div class="d-flex justify-space-between my-5 mx-4 text-white">
						<div>{{ $t('create_certificate') }}</div>
						<div @click="isAddItemsDialogOpen = false"><v-icon>mdi-close</v-icon></div>
					</div>
				</v-card-header>
				<v-card-text>
					<div>
						<div>{{ $t('certificate_name') }}</div>
						<div class='mt-3'><v-text-field :placeholder="$t('name')" variant="outlined"
								v-model="name"></v-text-field>
						</div>
						<div class="d-flex flex-row-reverse">
							<v-btn :disabled="!name" rounded="xl" color="rgba(46, 204, 113, 1)"
								class="text-none text-white px-5" @click="addCertificate">{{ $t('confirm') }}</v-btn>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialog" max-width="500" persistent>
			<v-card rounded=xl>

				<v-card-text class="mx-2 my-4">
					Are you sure you want to delete the certificate <strong style="color:rgba(255, 126, 135, 1)">"{{
						certificateToDelete }}"</strong>?
				</v-card-text>
				<v-card-footer style="background-color: black;color: white;">
					<div class="d-flex justify-space-between ma-2">
						<v-btn variant="text" text @click="cancelDelete()" class='text-none'>{{ $t('cancel') }}</v-btn>
						<v-btn variant=text text @click="confirmDelete(this.certificateToDeleteId)">
							<div class="d-flex align-center text-none">
								<div class="mr-2">{{ $t('confirm') }} </div>
								<div><v-icon size="x-large">mdi-arrow-right-thin-circle-outline</v-icon></div>
							</div>
						</v-btn>

					</div>

				</v-card-footer>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import Vue3TagsInput from 'vue3-tags-input'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import AgentCertificate from '@/services/API/AgentCertificate';
export default {
	created() {
		this.fetchCertificates()
		this.agent = this.agentDetails
		this.agent.agentCertificate.forEach((item) => {
			this.selectedCertificates.push(item.certificateName)
		})
		this.tags = this.agent.skills ? this.agent.skills.map((skill) => skill.name) : []

	},
	components: {
		VueDatePicker,
		Vue3TagsInput,
	},
	props: {
		agentDetails: {
			type: Object,
			required: false,
		},
	},
	emits: ['emitUpdateAgentProfile', 'closeDialog'],
	methods: {
		triggerFileInput() {
			this.$refs.fileInput.click(); // Trigger click on the hidden file input
		},
		handleFileChange(event) {
			const file = event.target.files;
			this.selectedFiles.push(...file);
			// Store selected files
		},
		async removeFile(index) {
			if (this.agent.agentDocument.includes(this.selectedFiles[index])) {
				await agentProfileService.deleteAgentDocument(this.selectedFiles[index].id);
			}

			this.selectedFiles.splice(index, 1);

		},
		toggleCertificateSelection(item) {
			if (this.selectedCertificates.includes(item)) {
				this.selectedCertificates = this.selectedCertificates.filter(
					(selectedItem) => selectedItem !== item
				);
			} else {
				this.selectedCertificates = [...this.selectedCertificates, item];
			}
		},
		handleAddItemsDialogOpen() {
			this.name = '';
			this.isAddItemsDialogOpen = true;
			this.isCreateCertificatesOpen = false;
			this.isCreateNewProjectDialogOpen = false;
		},
		async addCertificate() {
			if (this.name) {
				const resp = await AgentCertificate.postNewCertificateName({ certificateName: this.name })
				if (await resp.status === 200) {
					this.certificates.push(this.name); // Add the new certificate
					// this.name = ''; // Reset the input field
					this.fetchCertificates()
					this.isAddItemsDialogOpen = false; // Close the dialog
				}

			}
		},
		deleteCertificatePopup(id, name) {
			if (this.selectedCertificates.includes(name)) {
				this.toggleCertificateSelection(name)
			}

			this.certificateToDelete = name;
			this.certificateToDeleteId = id;
			this.dialog = true; // Open the dialog
		},
		async confirmDelete(id) {
			await AgentCertificate.deleteCertificate(id).then(() => {
				this.dialog = false;
				this.fetchCertificates();
			})
		},
		cancelDelete() {
			this.agent.agentCertificate.forEach((item) => {
				if (this.selectedCertificates.includes(item.certificateName)) {
					this.dialog = false
				} else {
					this.toggleCertificateSelection(this.certificateToDelete)
				}
			})
			this.dialog = false;

		},
		async fetchCertificates() {
			try {
				const response = await AgentCertificate.getAllCertificateName();
				if (response.status === 200) {
					this.certificates = response.data.map(cert => ({ id: cert.id, name: cert.certificateName }));
				} else {
					console.error('Failed to fetch certificates');
				}
			} catch (error) {
				console.error('An error occurred while fetching certificates:', error);
			}
		},
		closeDialog() {
			this.$emit('closeDialog')
		},
		pickFile() {
			this.$refs.fileRef.click()
		},
		uploadImage(event) {
			const file = event.target.files[0];

			if (file) {
				if (this.agent.pictureUrl) {
					URL.revokeObjectURL(this.agent.pictureUrl);
				}
				this.file = file
				this.agent.pictureUrl = URL.createObjectURL(file);
			}
		},
		handleChangeTag(tags) {
			this.tags = tags
		},
		getMappedAgentType() {
			if (this.agent.roles[0]?.type === 'general') return 'IT Service';
			if (this.agent.roles[0]?.type === 'esg') return 'ESG';
			return null;
		},
		setMappedAgentType(value) {
			// Ensure agent.roles is initialized
			if (!this.agent.roles || this.agent.roles.length === 0) {
				this.agent.roles = [{ type: '' }];
			}
			// Update the type based on the selected value
			this.agent.roles[0].type = value === 'IT Service' ? 'general' : 'esg';
		},
		updateAgentProfile() {
			this.formObj.id = this.agent.id;
			this.formObj.firstName = this.agent.firstName;
			this.formObj.lastName = this.agent.lastName;
			this.formObj.email = this.agent.email;
			this.formObj.phone = this.agent.phone;
			this.formObj.address = this.agent.address;
			this.formObj.nickname = this.agent.nickname;
			this.formObj.certificateNames = this.selectedCertificates;
			this.formObj.preferredContactTime = this.agent.preferredContactTime;
			this.formObj.availableTime = this.agent.availableTime;
			this.formObj.remote = this.agent.remote;
			this.formObj.skills = this.tags;
			this.formObj.documentUrl = this.selectedFiles;
			this.formObj.pictureUrl = this.file;
			this.formObj.type = this.agent.roles[0]?.type || '';
			this.$emit('emitUpdateAgentProfile', this.formObj);
			this.closeDialog()
		},
		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)

			return `#${hex}`
		},
	},
	data: () => ({
		agent: {},
		file: null,
		tags: [],
		skills: [],
		skillset: [],
		isCreateCertificatesOpen: false,
		isCreateNewProjectDialogOpen: false,
		isAddItemsDialogOpen: false,
		certificateToDelete: null,
		certificateToDeleteId: null,
		selectedFiles: [],
		selectedCertificates: [],
		certificates: [],
		dialog: false,
		name: "",
		timeRange: [
			'24 hours',
			'Morning',
			'Afternoon',
			'After 6:00 PM',
			'After 10:00 PM',
		],
		loader: {
			showSubmittingLoader: false,
		},
		formObj: {
			id: null,
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			address: "",
			certificateNames: [],
			preferredContactTime: "",
			availableTime: "",
			nickname: "",
			remote: false,
			skills: [],
			pictureUrl: "",
			type: '',
		}
	}),
}
</script>

<style scoped>
.v-text-field fieldset {
	color: red !important;
	background-color: green !important;
	border-radius: 4px !important;
	border: #3dc4fa !important;
}

.create-card {
	width: 75vw;
	font-family: Roboto;
	font-weight: 600;
}

.second-col {
	scrollbar-width: none;
	-ms-overflow-style: none;
	/* For Internet Explorer and Edge */
}

.second-col::-webkit-scrollbar {
	display: none;
}

.card__title__top,
.card__title__bottom {
	color: white;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
}

.icon {
	justify-self: right;
}

.new-detail {
	color: #a3a3a3;
	text-decoration: none;
}

.reset-button {
	justify-self: self-start;
	font-size: 1.3rem;
	margin-left: 1rem;
}

.create-button {
	justify-self: end;
	font-size: 1.3rem;
	margin-right: 1rem;
}

.card__footer {
	color: white;
}

.new-job-detail-form,
.job-detail-form {
	margin-top: 1rem;
}

.loader {
	width: 70%;
}

.max-height {
	max-height: 576px;
}

.v-list-item--active {
	background-color: #3273f6 !important;
	color: white !important;
	border-radius: 10px;
}

.v-text-field-height {
	min-height: 47px;
	/* Adjust this height to match your v-text-field */
	padding: 0 12px;
	/* Adjust padding to align content vertically */
	display: flex;
	align-items: center;
	/* Align items vertically within the div */
	box-sizing: border-box;
	/* Include padding and border in height calculation */
}

.responsive-phone-field {
	padding: 0.3rem;
	width: 100%;
	/* Set initial width to 100% */
}
</style>
